const global = window

inputs.types.coordinate = function (data, name, niceName, type, input, parent, inputWindow) {
    let inputArea = input.parent('.field__area')
    inputArea.mousedown(function (e, handler) {
        inputArea.addClass('field--active')
    })
    inputArea.mouseup(function (e, handler) {
        inputArea.removeClass('field--active')
    })
    inputArea.mousemove(function (e, handler) {
        if (inputArea.hasClass('field--active')) {
            input.val(parseInt(e.offsetX) + ',' + parseInt(e.offsetY))
            input.change()
        }
    })
    input.change(function () {
        let inputArea = input.parent('.field__area')
        let pos = inputArea.find('.field__pos')
        pos.css('left', input.val().split(',')[0] + 'px')
        pos.css('top', input.val().split(',')[1] + 'px')
    })
    input.change()
    return data
}
